module.exports = __webpack_public_path__ + "img/enviroment.6d46011d.svg";